import { forwardRef, useImperativeHandle, useState } from "react";

import { getLanguage } from "../../../utils/getLanguage";
import CustomModal from "../../CustomModal";

const PremiumVideoModal = forwardRef(({}, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const lang = getLanguage();

  const premiumEnglishVideo =
    "https://cdn-static-images-frontend.s3.eu-west-1.amazonaws.com/hellocodeV2/HelloCodeVideo-EnglishRV5-Compress.mp4";
  const premiumArabicVideo =
    "https://cdn-static-images-frontend.s3.eu-west-1.amazonaws.com/hellocodeV2/HelloCodeVideo-ArabicRV4-Compress.mp4";

  // Choose video based on current language
  const videoSrc = lang === "ar" ? premiumArabicVideo : premiumEnglishVideo;

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  useImperativeHandle(ref, () => ({
    openModal() {
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  return (
    <CustomModal
      isOpen={isOpen}
      withCloseButton={true}
      onClose={handleCloseModal}
      className="max-w-[60rem] rounded-3xl border-8 border-blue-500 bg-[#F1F1F1] shadow-xl"
      contentClassname="!p-10 bg-[#F1F1F1]"
    >
      <video src={videoSrc} className="w-full rounded-lg" controls autoPlay />
    </CustomModal>
  );
});

export default PremiumVideoModal;
